import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';
import Badge from '@material-ui/core/Badge';
import Avatar from '@material-ui/core/Avatar';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Checkbox from '@material-ui/core/Checkbox';
import Tooltip from '@material-ui/core/Tooltip';
import ListSubheader from '@material-ui/core/ListSubheader';
import { setData, setDataBatch } from '../../actions/index';

const styles = () => ({
  heading: {
    fontSize: 16,
    color: '#616161',
    padding: '16px 16px 0',
  },
  entry: {},
  entryActive: {},
  entryInactive: {
    color: '#9e9e9e',
  },
  avatar: {
    color: '#212121',
    height: 28,
    width: 28,
    fontSize: 12,
    marginRight: 10,
  },
  avatarActive: {
    backgroundColor: '#bbdefb',
  },
  avatarInactive: {
    backgroundColor: '#eeeeee',
  },
  inlineBlock: {
    display: 'inline-block',
  },
});

const mapStateToProps = state => {
  return {
    messagesSelectedThread: state.messagesSelectedThread,
    messagesMultipleMessage: state.messagesMultipleMessage,
    messagesMultipleMessageSelectedIds: state.messagesMultipleMessageSelectedIds,
  };
};

function mapDispatchToProps(dispatch) {
  return {
    setData: (data, type) => dispatch(setData(data, type)),
    setDataBatch: (data) => dispatch(setDataBatch(data)),
  };
}

class MessageThreadsEntriesList extends React.Component {
  constructor(props) {
    super(props);

    this.onCheckEntry = this.onCheckEntry.bind(this);
  }

  componentDidMount() {
    window.addEventListener('messaging:check-entry', this.onCheckEntry);
  }

  componentWillUnmount() {
    window.removeEventListener('messaging:check-entry', this.onCheckEntry);
  }

  onCheckEntry(event) {
    const detail = event.detail;

    if (
      detail.type !== this.props.type ||
      (
        detail.parentEntry &&
        this.props.parentEntry &&
        detail.parentEntry !== this.props.parentEntry
      )
    ) {
      return;
    }

    this.onEntryCheckboxChange(
      detail.entry,
      detail.parentEntry,
      detail.subEntriesKey
    );
  }

  onEntryClick(entry, event) {
    const {
      messagesMultipleMessage,
      onClick,
    } = this.props;

    if (messagesMultipleMessage) {
      return;
    }

    onClick(entry, event);
  }

  onEntryCheckboxChange(entry, parentEntry, subEntriesKey) {
    const {
      messagesSelectedThread,
      messagesMultipleMessageSelectedIds,
    } = this.props;

    if (
      entry?.can_message === 'no' ||
      parentEntry?.can_message === 'no'
    ) {
      return;
    }

    // TODO: simplify stuff in here

    let newMessagesMultipleMessageSelectedIds = { ...messagesMultipleMessageSelectedIds };

    if (parentEntry) {
      if (entry) {
        if (
          typeof newMessagesMultipleMessageSelectedIds[parentEntry.id] === 'undefined' ||
          typeof newMessagesMultipleMessageSelectedIds[parentEntry.id][entry.id] === 'undefined'
        ) {
          // In case you haven't manually clicked the `parentEntry` yet
          if (typeof newMessagesMultipleMessageSelectedIds[parentEntry.id] === 'undefined') {
            newMessagesMultipleMessageSelectedIds[parentEntry.id] = {};
          }

          newMessagesMultipleMessageSelectedIds[parentEntry.id][entry.id] = entry.name +
            ' (pupil: ' + parentEntry.name + ')';
        } else {
          delete newMessagesMultipleMessageSelectedIds[parentEntry.id][entry.id];
        }
      } else {
        // If you click the `parentEntry` itself, the `entry` will be null
        if (typeof newMessagesMultipleMessageSelectedIds[parentEntry.id] === 'undefined') {
          newMessagesMultipleMessageSelectedIds[parentEntry.id] = {};

          if (typeof parentEntry[subEntriesKey] !== 'undefined') {
            for (let i = 0; i < parentEntry[subEntriesKey].length; i++) {
              const subEntry = parentEntry[subEntriesKey][i];
              if (subEntry.can_message === 'no') {
                continue;
              }

              newMessagesMultipleMessageSelectedIds[parentEntry.id][subEntry.id] = subEntry.name +
                ' (pupil: ' + parentEntry.name + ')';
            }
          }
        } else {
          delete newMessagesMultipleMessageSelectedIds[parentEntry.id];
        }
      }
    } else {
      if (typeof newMessagesMultipleMessageSelectedIds[entry.id] === 'undefined') {
        newMessagesMultipleMessageSelectedIds[entry.id] = entry.name;
      } else {
        delete newMessagesMultipleMessageSelectedIds[entry.id];
      }
    }

    const hasSelectedIds = (
      Object.keys(newMessagesMultipleMessageSelectedIds).length &&
      (
        // Any pupil selected
        typeof Object.values(newMessagesMultipleMessageSelectedIds)[0] === 'string' ||
        (
          // Any parent + parent's pupil selected
          typeof Object.values(newMessagesMultipleMessageSelectedIds)[0] === 'object' &&
          Object.keys(Object.values(newMessagesMultipleMessageSelectedIds)[0]).length
        )
      )
    );

    let newData = {
      messagesMultipleMessageSelectedIds: newMessagesMultipleMessageSelectedIds,
    };

    if (
      !hasSelectedIds &&
      messagesSelectedThread !== null
    ) {
      newData.messagesSelectedThread = null;
    }

    this.props.setDataBatch(newData);
  }

  isEntryChecked(entry, parentEntry) {
    const {
      messagesMultipleMessageSelectedIds
    } = this.props;

    if (parentEntry && entry) {
      return !!(
        messagesMultipleMessageSelectedIds[parentEntry.id] &&
        typeof messagesMultipleMessageSelectedIds[parentEntry.id][entry.id] !== 'undefined'
      );
    }

    if (parentEntry && !entry) {
      return typeof messagesMultipleMessageSelectedIds[parentEntry.id] !== 'undefined';
    }

    return typeof messagesMultipleMessageSelectedIds[entry.id] !== 'undefined';
  }

  isEntryDisabled(entry, parentEntry) {
    if (!entry && !parentEntry) {
      return true;
    }

    if (!entry) {
      return parentEntry.can_message === 'no';
    }

    return entry.can_message === 'no';
  }

  render() {
    const {
      classes,
      t,
      messagesSelectedThread,
      subheaderContent,
      parentEntry,
      entries,
      subEntriesKey,
      showEntries,
      messagesMultipleMessage,
      listType,
    } = this.props;

    const hasEntries = entries && entries.length > 0;
    const noEntriesText = appType === 'teacher' || appType === 'teacher_admin'
      ? t('No parent accounts associated with pupil')
      : t('No entries found');
    const parentDisabled = this.isEntryDisabled(null, parentEntry);

    return (
      <List
        className="message-threads-entries-list"
        dense={true}
        subheader={subheaderContent ? (
          <ListSubheader>
            {messagesMultipleMessage && (
              <Tooltip title={parentDisabled ? t('The selected thread was locked') : ''}>
                <div className={classes.inlineBlock}>
                  <Checkbox
                    color="primary"
                    checked={this.isEntryChecked(null, parentEntry)}
                    disabled={parentDisabled}
                    onChange={this.onEntryCheckboxChange.bind(this, null, parentEntry, subEntriesKey)}
                  />
                </div>
              </Tooltip>
            )}
            {subheaderContent}
          </ListSubheader>
        ) : null}
        style={{
          paddingBottom: showEntries && hasEntries ? 8 : 0,
        }}
      >
        {showEntries && !hasEntries && listType === 'parent' && (
          <ListItem
            className={`${classes.entry} ${classes.entryInactive}`}
          >
            <ListItemText
              primary={noEntriesText}
            />
          </ListItem>
        )}
        {showEntries && hasEntries && entries.map((entry) => {
          let primaryText = entry.name;
          if (
            entry.pupil_name &&
            appType === 'teacher_admin'
          ) {
            primaryText += ' ' + t('for') + ' ' + entry.pupil_name;
          }

          if (entry.thread?.new_messages > 0) {
            primaryText = (
              <React.Fragment>
                <Badge
                  variant="dot"
                  color="secondary"
                >
                  {primaryText}
                </Badge>
              </React.Fragment>
            );
          }

          const key = (entry.id + '') + (entry.pupil_name ? '+' + entry.pupil_name : '');
          const hasBeenContacted = !!entry.thread?.last_message;

          const secondaryText = hasBeenContacted
              ? moment(entry.thread.last_message).fromNow()
              : null;

          let isSelected = false;
          if (
            entry.thread &&
            messagesSelectedThread?.thread
          ) {
            isSelected = entry.thread.id === messagesSelectedThread.thread.id;
          } else {
            isSelected = messagesSelectedThread && (
              (
                !messagesSelectedThread.pupil_id &&
                messagesSelectedThread.id === entry.id
              ) ||
              (
                messagesSelectedThread.pupil_id &&
                messagesSelectedThread.id === entry.id &&
                messagesSelectedThread.pupil_id === entry.pupil_id
              )
            );
          }

          const entryClassName = hasBeenContacted
            ? `${classes.entry} ${classes.entryActive}`
            : `${classes.entry} ${classes.entryInactive}`;
          const avatarClassName = hasBeenContacted
            ? `${classes.avatar} ${classes.avatarActive}`
            : `${classes.avatar} ${classes.avatarInactive}`;
          const disabled = this.isEntryDisabled(entry, parentEntry);

          return (
            <ListItem
              key={key}
              button
              onClick={this.onEntryClick.bind(this, entry)}
              selected={isSelected}
              className={entryClassName}
            >
              {messagesMultipleMessage && (
                <Tooltip title={disabled ? t('The selected thread was locked') : ''}>
                  <div className={classes.inlineBlock}>
                    <Checkbox
                      color="primary"
                      checked={this.isEntryChecked(entry, parentEntry)}
                      disabled={disabled}
                      onChange={this.onEntryCheckboxChange.bind(this, entry, parentEntry, subEntriesKey)}
                    />
                  </div>
                </Tooltip>
              )}
              <Avatar className={avatarClassName}>{entry.avatar}</Avatar>
              <ListItemText
                primary={primaryText}
                secondary={secondaryText}
              />
            </ListItem>
          )
        })}
      </List>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(
  withStyles(styles)(withTranslation()(MessageThreadsEntriesList))
);
